export enum BrokerModals {
  BLOCK_BROKER_MODAL = 'BLOCK_BROKER_MODAL',
  UNBLOCK_BROKER_MODAL = 'UNBLOCK_BROKER_MODAL',
  DELETE_BROKER_MODAL = 'DELETE_BROKER_MODAL',
}
